/* VX-Power bundle display: reads bundles from the Bundler app (window.bndlr.getBundles)
   and renders them in the VX design. Adds the real standalone items to the cart;
   Bundler applies the bundle discount. */
(function () {
  'use strict';

  var money = function (cents) {
    var v = (cents / 100);
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var img = function (src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  };

  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function waitForBundles(timeoutMs) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function check() {
        try {
          if (window.bndlr && typeof window.bndlr.getBundles === 'function') {
            var b = window.bndlr.getBundles();
            if (Array.isArray(b) && b.length) return resolve(b);
          }
        } catch (e) {}
        if (Date.now() - start > timeoutMs) return resolve([]);
        setTimeout(check, 250);
      })();
    });
  }

  function isClassic(b) {
    return b && b.status === 'enabled' && b.show_bundle !== 'false' &&
      b.is_volume_bundle !== 'true' && b.is_quantity_break !== 'true' &&
      b.is_frequently_purchased_bundle !== 'true' && b.products && Object.keys(b.products).length > 1;
  }

  function bundleItems(b) {
    return Object.keys(b.products).map(function (k) { return b.products[k]; })
      .sort(function (a, c) { return (a.sequence || 0) - (c.sequence || 0); });
  }

  /* Build the data model for one bundle: each item with its Shopify product + allowed variants */
  function loadBundle(b) {
    var items = bundleItems(b);
    return Promise.all(items.map(function (it) { return getProduct(it.handle); })).then(function (prods) {
      var model = { bundle: b, items: [] };
      for (var i = 0; i < items.length; i++) {
        var p = prods[i];
        if (!p) return null;
        var allowed = Object.keys(items[i].variants || {});
        var variants = p.variants.filter(function (v) {
          return !allowed.length || allowed.indexOf(String(v.id)) > -1;
        });
        if (!variants.length) return null;
        model.items.push({ product: p, qty: items[i].quantity || 1, variants: variants });
      }
      return model;
    });
  }

  function priceFor(model, selected) {
    var total = 0;
    model.items.forEach(function (it, i) {
      var v = it.variants.filter(function (x) { return String(x.id) === String(selected[i]); })[0] || it.variants[0];
      total += v.price * it.qty;
    });
    var b = model.bundle, final = total;
    if (b.discount_type === 'fixed_price' && b.fixed_price_value) final = Math.round(parseFloat(b.fixed_price_value) * 100);
    else if (b.discount_type === 'percentage' && b.percentage_value) final = Math.round(total * (1 - parseFloat(b.percentage_value) / 100));
    else if (b.discount_type === 'fixed_amount' && b.fixed_amount_value) final = total - Math.round(parseFloat(b.fixed_amount_value) * 100);
    return { total: total, final: Math.min(final, total) };
  }

  function variantLabel(v) {
    return v.title && v.title !== 'Default Title' ? v.title : '';
  }

  function defaultSel(model, currentVariantId) {
    return model.items.map(function (it) {
      var pref = it.variants.filter(function (v) { return String(v.id) === String(currentVariantId) && v.available; })[0];
      var firstAvail = it.variants.filter(function (v) { return v.available; })[0];
      return String((pref || firstAvail || it.variants[0]).id);
    });
  }

  function cardHTML(model, idx, currentVariantId) {
    var sel = defaultSel(model, currentVariantId);
    model.sel = sel;
    var pr = priceFor(model, sel);
    var save = pr.total - pr.final;
    var allAvail = model.items.every(function (it) { return it.variants.some(function (v) { return v.available; }); });

    var items = model.items.map(function (it, i) {
      var p = it.product;
      var multi = it.variants.length > 1;
      var cur = it.variants.filter(function (v) { return String(v.id) === sel[i]; })[0] || it.variants[0];
      var vimg = (cur.featured_image && cur.featured_image.src) || p.featured_image;
      var select = '';
      if (multi) {
        select = '<select class="vxb-select" data-item="' + i + '" aria-label="' + esc(p.title) + ' color">' +
          it.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (String(v.id) === sel[i] ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
              esc(variantLabel(v) || 'Option') + (v.available ? '' : ' (sold out)') + '</option>';
          }).join('') + '</select>';
      }
      return '<div class="vxb-item">' +
        '<a class="vxb-item__img" href="' + esc(p.url) + '">' + (vimg ? '<img src="' + esc(img(vimg, 220)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="vxb-item__body"><a class="vxb-item__title" href="' + esc(p.url) + '">' + (it.qty > 1 ? it.qty + ' x ' : '') + esc(p.title) + '</a>' +
        '<span class="vxb-item__price">' + money(cur.price) + '</span>' + select + '</div></div>';
    }).join('<span class="vxb-plus" aria-hidden="true">+</span>');

    return '<div class="vxb-card" data-idx="' + idx + '">' +
      '<div class="vxb-card__head"><span class="vxb-card__name">' + esc(model.bundle.name) + '</span>' +
      (save > 0 ? '<span class="vxb-save" data-save>Save ' + money(save) + '</span>' : '') + '</div>' +
      '<div class="vxb-items">' + items + '</div>' +
      '<div class="vxb-foot"><div class="vxb-price"><strong data-final>' + money(pr.final) + '</strong>' +
      (save > 0 ? '<s data-total>' + money(pr.total) + '</s>' : '') + '</div>' +
      '<button type="button" class="vxb-btn" data-add' + (allAvail ? '' : ' disabled') + '>' + (allAvail ? 'Add bundle to cart' : 'Sold out') + '</button></div>' +
      '</div>';
  }

  function bind(root, models) {
    root.addEventListener('change', function (e) {
      var s = e.target.closest('.vxb-select'); if (!s) return;
      var card = s.closest('.vxb-card'); var m = models[+card.getAttribute('data-idx')];
      m.sel[+s.getAttribute('data-item')] = s.value;
      var it = m.items[+s.getAttribute('data-item')];
      var v = it.variants.filter(function (x) { return String(x.id) === s.value; })[0];
      if (v) { var ps = s.closest('.vxb-item').querySelector('.vxb-item__price'); if (ps) ps.textContent = money(v.price); }
      if (v && v.featured_image && v.featured_image.src) {
        var im = s.closest('.vxb-item').querySelector('img'); if (im) im.src = img(v.featured_image.src, 220);
      }
      var pr = priceFor(m, m.sel);
      card.querySelector('[data-final]').textContent = money(pr.final);
      var t = card.querySelector('[data-total]'); if (t) t.textContent = money(pr.total);
      var sv = card.querySelector('[data-save]'); if (sv) sv.textContent = 'Save ' + money(pr.total - pr.final);
    });
    root.addEventListener('click', function (e) {
      var more = e.target.closest('[data-more]');
      if (more) { root.classList.add('is-expanded'); more.remove(); return; }
      var btn = e.target.closest('[data-add]'); if (!btn || btn.disabled) return;
      var card = btn.closest('.vxb-card'); var m = models[+card.getAttribute('data-idx')];
      var items = m.items.map(function (it, i) { return { id: Number(m.sel[i]), quantity: it.qty }; });
      btn.disabled = true; var label = btn.textContent; btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
        try { if (window.bndlr && typeof window.bndlr.refresh === 'function') window.bndlr.refresh(); } catch (err) {}
        window.location.href = '/cart';
      }).catch(function (err) {
        btn.disabled = false; btn.textContent = label;
        var msg = card.querySelector('.vxb-error') || document.createElement('p');
        msg.className = 'vxb-error'; msg.textContent = err.message; card.appendChild(msg);
      });
    });
  }

  function init(root) {
    var productId = root.getAttribute('data-product-id');
    var limit = parseInt(root.getAttribute('data-limit') || '0', 10);
    var currentVariant = root.getAttribute('data-variant-id');
    waitForBundles(15000).then(function (all) {
      var list = all.filter(isClassic);
      if (productId) list = list.filter(function (b) { return Object.prototype.hasOwnProperty.call(b.products, String(productId)); });
      list.sort(function (a, c) { return (a.priority || 0) - (c.priority || 0); });
      if (!list.length) return;
      return Promise.all(list.map(loadBundle)).then(function (models) {
        /* only show bundles that actually save money vs. buying the items separately */
        models = models.filter(function (m) {
          if (!m) return false;
          var pr = priceFor(m, defaultSel(m, currentVariant));
          return pr.total - pr.final > 0;
        });
        if (!models.length) return;
        var html = models.map(function (m, i) { return cardHTML(m, i, currentVariant); }).join('');
        var listEl = root.querySelector('[data-vxb-list]');
        listEl.innerHTML = html;
        if (limit && models.length > limit) {
          root.classList.add('is-limited'); root.style.setProperty('--vxb-limit', limit);
          var cards = listEl.querySelectorAll('.vxb-card');
          for (var i = limit; i < cards.length; i++) cards[i].classList.add('vxb-card--extra');
          var more = document.createElement('button');
          more.type = 'button'; more.className = 'vxb-more'; more.setAttribute('data-more', '');
          more.textContent = 'Show ' + (models.length - limit) + ' more bundle' + (models.length - limit > 1 ? 's' : '');
          listEl.after(more);
        }
        var c = root.querySelector('[data-vxb-count]'); if (c) c.textContent = models.length;
        root.hidden = false;
        bind(root, models);
      });
    });
  }

  function start() { document.querySelectorAll('[data-vxb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
